import { Trans } from '@lingui/react/macro'

const InviteExpired = () => {
  return (
    <div className='w-96 flex flex-col gap-2 text-center'>
      <h4 className='text-neutral-900 font-medium leading-normal text-base'>
        <Trans>This invite link is no longer valid</Trans>
      </h4>
      <p className='text-sm text-center text-neutral-700'>
        <Trans>
          Invite links can only be used once and will expire after 24h.
          <br />
          If you already opened this link before, or it has expired, please
          contact your admin to request a new one.
        </Trans>
      </p>
    </div>
  )
}

export default InviteExpired
